import { requestApi } from '../util/network'

// 获取学生信息
export const getStudentIndex =
    () =>
      requestApi(
        '/student/Index/index',
        'GET',
				{
				},
				'student'
      )
			
// 获取教学评估
export const getEvaluation =
    () =>
      requestApi(
        '/index.php/student/scoremanage/appraise',
        'POST',
				{
				},
				'student'
      )

// 教学评估页提交试卷
export const evaluationSubmitPaper =
    (data) =>
      requestApi(
        '/student/scoremanage/submit_answers',
        'POST',
				data,
				'student'
      )

// 获取学习任务
export const getTask =
    () =>
      requestApi(
        '/index.php/student/index/course',
        'POST',
				{
				},
				'student'
      )
			
// 规划书添加
export const planAdd =
		(addObj) =>
			requestApi(
				'/index.php/student/plan/add',
				'POST',
				{
					'seller_name': addObj.sellerName,
					'store_name':  addObj.storeName,
					'store_url': addObj.storeUrl,
					'product_type': addObj.productType,
					'source_supply': addObj.sourceSupply,
					'customer_position': addObj.customerPosition,
					'price_position': addObj.pricePosition,
					'products_num': addObj.productsNum,
					'credit_rank': addObj.creditRank,
					'start_funds': addObj.startFunds,
					'fixed_funds': addObj.fixedFunds,
					'flow_funds': addObj.flowFunds,
					'recruits_num': addObj.recruitsNum,
					'people_division': addObj.peopleDivision,
					'promote_free': addObj.promoteFree,
					'expected_free': addObj.expectedFree,
					'promote_charges': addObj.promoteCharges,
					'expected_input': addObj.expectedInput,
					'expected_output': addObj.expectedOutput,
					'visitors_num': addObj.visitorsNum,
					'conver_rate': addObj.converRate,
					'visitors_deal_num': addObj.visitorsDealNum,
					'customer_price': addObj.customerPrice,
					'revenue': addObj.revenue,
					'total_cost': addObj.totalCost,
					'income': addObj.income
				},
				'student'
			)
			
// 获取规划书详情
export const getPlan =
    () =>
      requestApi(
        '/student/plan/index',
        'GET',
				{
				},
				'student'
      )

// 获取成果详情
export const getAchieve =
    () =>
      requestApi(
        '/student/gain/index',
        'GET',
				{
				},
				'student'
      )

// 添加成果
export const addAchieve =
    (addObj) =>
      requestApi(
        '/student/gain/add',
        'POST',
				addObj,
				'student'
      )

// 成果图片上传
export const uploadAchieveImg =
    (file) =>
      requestApi(
        '/student/gain/image_upload',
        'POST',
				file,
				'student',
				true // 上传图片时 类型是headers Content-Type multipart/form-data
      )

// 理论考试页面
export const getPage =
    (paperId) =>
      requestApi(
        '/student/scoremanage/index',
        'GET',
				{
					'paper_id': paperId
				},
				'student'
      )

// 提交理论考试
export const submitPage =
    (data) =>
      requestApi(
        '/student/scoremanage/submit_answers',
        'POST',
				data,
				'student'
      )
